import API from '@/api/index';

const billing = {
  state: {
  },

  mutations: {},

  actions: {
    LockVehicle ({ commit }, id) {
      return new Promise((resolve, reject) => {
        API.billing
          .LockVehicle(id)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    UnlockVehicle ({ commit }, id) {
      return new Promise((resolve, reject) => {
        API.billing
          .UnlockVehicle(id)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    SearchSim ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.billing
          .SearchSim(data)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};

export default billing;



// WEBPACK FOOTER //
// ./src/store/modules/billing.js